function initializeCookiePreferences() {
  const button = document.getElementById('mtn-cookie-preferences');
  if (!button || !window.privacyBanner?.showPreferences) return;
  button.hidden = false;
  button.addEventListener('click', () => {
    window.privacyBanner.showPreferences();
  });
}
if (document.readyState === 'complete') {
  initializeCookiePreferences();
} else {
  window.addEventListener('load', initializeCookiePreferences, { once: true });
}
